/*
 |--------------------------------------------------------------------------
 | Meer informatie module
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

//no imports needed

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const
	/**
	 * The module name
	 * @type {String}
	 */
	moduleName = 'meer-info',
	/**
	* Lookup table with class names
	* @type {Object}
	*/
	classNames = {
		base: `js-${ moduleName }`},
	/**
	 * Lookup table for selectors
	 * @type {Object}
	 */
	selectors = {
		base: `.js-${ moduleName }`,
		container: `.js-${ moduleName }-container`};

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP MEER INFORMATIE
 \* ========================================================================== */

class MeerInformatie {
	constructor(heading) {
		this.heading = heading;
	}

	toggleMeerInformatie() {
		if(document.querySelectorAll(this.heading) == undefined || document.querySelectorAll(this.heading).length == 0)
			return;

		const meerInformatieHeading = Array.prototype.slice.call(document.querySelectorAll(this.heading));

		meerInformatieHeading.forEach((item, key) => {
			item.addEventListener('click', () => {
				//close opened meerInformaties
				meerInformatieHeading.forEach(element => {
					if(element.classList.contains('active') && element !== item){
						element.classList.remove('active');
					}
				});
				//open clicked meerInformatie
				item.classList.toggle('active');
			});
			//open first meerInformatie by default
			if (key === 0) {
				item.classList.add('active')
			}
		});
	}
}

const meerInformatie = new MeerInformatie(selectors.container);

/* == END SETUP MEER INFORMATIE ===================================================== */

/* ========================================================================== *\
 EVENT HANDLING
 \* ========================================================================== */

// No event handling needed

 /* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
 INITIALIZATION
 \* ========================================================================== */

if (document.getElementsByClassName(classNames.base).length){
    meerInformatie.toggleMeerInformatie();
}

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
 EXPORTS
 \* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */

